import { InputGroup, FormControl, Button } from "react-bootstrap";
import "./InputWithButton2.scss";

const InputWithButton2 = (props) => {
  const OnChange = (val) => {
    props.setValue(val.target.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      props.doFunction();
    }
  };

  return (
    <InputGroup className="input-with-button">
      <div className="input-with-button-left">
        <InputGroup.Prepend className="input-group-icon">
          <InputGroup.Text>
            <props.icon fill="#DADADA" />
          </InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          className="input-group-prepend-input"
          placeholder={props.placeholder}
          value={props.value}
          onChange={OnChange}
          onKeyUp={handleKeyPress}
        />
      </div>
      <div className="input-with-button-right">
        <InputGroup.Append>
          <Button
            variant="warning"
            className="btn-min-width z-index-0"
            onClick={props.doFunction}
          >
            {props.buttonLabel}
          </Button>
        </InputGroup.Append>
      </div>
    </InputGroup>
  );
};

export default InputWithButton2;
